import React, { useEffect, Suspense } from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './i18n';
import Router from './Router';
import { selectUserUuid, setUserToken, setUuid } from './features/signup/signupSlice';
import * as Sentry from '@sentry/react';
import GlobalStyle from './globalStyles';
import UIAlert from './UI/Alert';
import Loader from './UI/Loader';
import ProgrBar from './UI/ProgrBar';
import AppContainer from './UI/Container';
import { useFontsLoader } from './helper/useFontsLoader';
import { fontFaces } from './fontFaces';
import useInlineScript from './helper/useInlineScript';
import tiktok from './scripts/tiktokPixel';
import FacebookPixel from 'react-facebook-pixel';
import { FB_PIXEL_ID } from './analytics/facebook';
import ReactGA from 'react-ga4';
import { REACT_APP_GOOGLE_TRACKING_ID, REACT_APP_GOOGLE_ADS_ID } from './analytics/GA';
import { queryParser } from 'onboarding-initialization';
import { GoogleOAuthProvider } from '@react-oauth/google';

const App = () => {
    const dispatch = useDispatch();
    const userUuid = useSelector(selectUserUuid);
    const { ttclid } = queryParser(window.location.search);
    const tiktokScript = ttclid ? tiktok : '';

    useInlineScript(tiktokScript, 'TiktokJelly');

    useFontsLoader(fontFaces)

    useEffect(() => {
        const storageToken = window.sessionStorage?.getItem('access_token');

        if (storageToken) {
            dispatch(setUserToken(storageToken))
        }

        dispatch(setUuid());
    }, [dispatch]);

    useEffect(() => {
        FacebookPixel.init(FB_PIXEL_ID, { 'external_id': userUuid });
        FacebookPixel.pageView();
    },[userUuid]);

    useEffect(() => {
        const initOptionsList = [
            { trackingId: REACT_APP_GOOGLE_TRACKING_ID },
            { trackingId: REACT_APP_GOOGLE_ADS_ID },
        ];
        if (REACT_APP_GOOGLE_TRACKING_ID && REACT_APP_GOOGLE_ADS_ID) {
            ReactGA.initialize(initOptionsList);
        }
    }, []);

    return (
			<GoogleOAuthProvider
				clientId={process.env.REACT_APP_GOOGLE_SIGNUP_CLIENT_ID}
			>
				<Suspense fallback={<Loader />}>
					<GlobalStyle />
					<Loader showMessage={true} />
					<AppContainer>
						<BrowserRouter>
							<ProgrBar />
							<Route path={['/']} component={Router} />
						</BrowserRouter>
					</AppContainer>
					<UIAlert />
				</Suspense>
			</GoogleOAuthProvider>
		);
};

export default Sentry.withProfiler(App);
